import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Typography } from '@mui/material';
import { SlideTransition } from '../../../components/Transition/Transition';

const VerifyDialog = props => {
  const { intl, name, email, open, onLogout, onCancel, onSubmit, ...rest } = props;

  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const onChange = event => setPassword(event.target.value);
  const formattedOnSubmit = event => {
    event.preventDefault();
    if (onSubmit) {
      setLoading(true);
      onSubmit(password);
    }
  };

  return (
    <Dialog
      open={open}
      maxWidth="xs"
      fullWidth={true}
      {...rest}
      slots={{
        transition: SlideTransition
      }}
    >
      <DialogTitle>{intl.formatMessage({ id: 'cap-login-verify-dialog-title' }, { name: name || email })}</DialogTitle>
      <DialogContent>
        <Grid container spacing={1} sx={{ flexDirection: 'column' }}>
          <form onSubmit={formattedOnSubmit}>
            <TextField
              type="password"
              label={intl.formatMessage({ id: 'Password' })}
              value={password}
              disabled={loading}
              onChange={onChange}
              slotProps={{
                htmlInput: {
                  style: {
                    boxSizing: 'content-box',
                    padding: '6px 0 7px'
                  }
                }
              }}
            />
          </form>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Grid
          container
          sx={{
            justifyContent: 'space-between'
          }}
        >
          <Grid>
            <Button color="primary" onClick={onLogout}>
              {intl.formatMessage({ id: 'Logout' })}
            </Button>
          </Grid>
          <Grid>
            <Button color="primary" onClick={onCancel}>
              {intl.formatMessage({ id: 'Cancel' })}
            </Button>
            <Button color="primary" onClick={formattedOnSubmit}>
              {intl.formatMessage({ id: 'OK' })}
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

export default injectIntl(VerifyDialog);
